/** "2026-08-24" -> "August 2026" (UTC, so the month never shifts with the viewer's timezone). */
export function formatUpdated(iso) {
  return new Date(`${iso}T00:00:00Z`).toLocaleDateString('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' });
}
